import { userResetPasswordSuccess, userResetPasswordError } from "./reducer";
import { resetPassword } from "helpers/AuthType/authBackend";

export const resetPasswordThunk =
  (user: any, token: any, history: any) => async (dispatch: any) => {
    try {
      let response: any;
      if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
        if (validateData(user)) {
          response = await resetPassword({
            token: token,
            newPassword: user.password,
          });
          console.log(token + "-----" + user.password);
          dispatch(userResetPasswordSuccess(user.email));
          history("/login");
        }
        dispatch(userResetPasswordError("Las contraseñas no coinciden"));
      }
      console.log(response);
    } catch (error) {
      dispatch(userResetPasswordError(error));
    }
  };

const validateData = (values: any) => {
  if (values.repeat_password !== values.password) {
    return false;
  }
  return true;
};
